import React from 'react';
import { AppRouter } from './router/index';
import { AuthProvider } from './providers/AuthProvider';
import { I18nProvider } from './providers/I18nProvider';
import { CompanyProvider } from './providers/CompanyProvider';
export function App() {
  return <AuthProvider data-id="element-0" data-mp="34nhb4wxjp6vn">
      <I18nProvider data-id="element-1" data-mp="2zqh52m0p444j">
        <CompanyProvider data-id="element-2" data-mp="2zpxy20cl305a">
          <AppRouter data-id="element-3" data-mp="2zppmqcw402w7" />
        </CompanyProvider>
      </I18nProvider>
    </AuthProvider>;
}